import { render, staticRenderFns } from "./FlagConfig.vue?vue&type=template&id=97724ad0&scoped=true"
import script from "./FlagConfig.vue?vue&type=script&lang=js"
export * from "./FlagConfig.vue?vue&type=script&lang=js"
import style0 from "./FlagConfig.vue?vue&type=style&index=0&id=97724ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97724ad0",
  null
  
)

export default component.exports